import { render, staticRenderFns } from "./InspirationDetail.vue?vue&type=template&id=23e8582c&scoped=true&"
import script from "./InspirationDetail.vue?vue&type=script&lang=js&"
export * from "./InspirationDetail.vue?vue&type=script&lang=js&"
import style0 from "./InspirationDetail.vue?vue&type=style&index=0&id=23e8582c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e8582c",
  null
  
)

export default component.exports